module.exports = __webpack_public_path__ + "static/img/spring_festival.36e5355b.gif";